'use client'

import React, { createContext, useContext, useState, ReactNode } from 'react'

interface SFCaseContextType {
  sfCaseId: string | null
  setSfCaseId: (id: string | null) => void
  reportSubTypes: string[]
  setReportSubTypes: (types: string[]) => void
}

const SFCaseContext = createContext<SFCaseContextType | undefined>(undefined)

export const useSFCase = () => {
  const context = useContext(SFCaseContext)
  if (context === undefined) {
    throw new Error('useSFCase must be used within a SFCaseProvider')
  }
  return context
}

interface SFCaseProviderProps {
  children: ReactNode
}

export const SFCaseProvider: React.FC<SFCaseProviderProps> = ({ children }) => {
  const [sfCaseId, setSfCaseId] = useState<string | null>(null)
  const [reportSubTypes, setReportSubTypes] = useState<string[]>([])

  return (
    <SFCaseContext.Provider value={{ sfCaseId, setSfCaseId, reportSubTypes, setReportSubTypes }}>
      {children}
    </SFCaseContext.Provider>
  )
}
